import React, { Fragment, useRef, useState } from 'react';
import { INavGroup, IRoute } from '../types';

import '../styles/base.css';
import '../assets/scss/default.scss';

import Title from '../components/atoms/Title';
import Header from '../components/atoms/Header';
import Menu from '../components/atoms/Menu';
import Bana from '../components/molecules/Bana';
import Footer from '../components/molecules/Footer';
import MembersLogin from '../components/atoms/MembersLogin';
import Submenu from '../components/molecules/SubMenu';
import SubMenuItem from '../components/atoms/SubMenuItem';

interface Props {
	path: string,
	title?: string,
	route: IRoute,
	navGroups?: INavGroup[],
	location: Location
}

const DefaultLayout: React.FC<Props> = props => {
	const { children, title, route, navGroups, location } = props

	const [fontSize, setFontSize] = useState({
		min: 100, max: 200,
		value: 100, unit: '%',
		increment: 1.1
	})

	const handleGoLarger = () => {
		if ((fontSize.value * fontSize.increment) >= fontSize.max) return
		setFontSize(fs => ({
			...fs, value: fs.value * fs.increment
		}))
	}
	function handleGoStandard() {
		if (fontSize.value <= fontSize.min) return
		setFontSize(fs => ({
			...fs, value: fontSize.min
		}))
	}

	return (
		<Fragment>
			{title && <title>{title}</title>}
			<Header />
			<Menu
				onGoLarger={handleGoLarger}
				onGoStandard={handleGoStandard}
			/>
			<Title
				title={route.title}
				desc={route.description}
				subtitle={route.subtitle}
				breadcrumb={route.breadcrumbs}
			/>
			<main
				className="main"
				style={{
					fontSize: `${fontSize.value + fontSize.unit}`
				}}>
				<div className="clearfix">
					<div className="main-left">
						{navGroups && navGroups.map(group => (
							<Submenu key={group.id} title={group.title}>
								{group.routes?.map(route => (
									<SubMenuItem
										key={route.id}
										label={route.nav?.label}
										link={route.nav?.link}
										exact={route.nav?.exact}
										currentRoute={location}
									/>
								))}
							</Submenu>
						))}
						<MembersLogin />
						<Bana />
					</div>
					<div className="main-right">
						<div className="content">
							{children}
						</div>
					</div>
				</div>
			</main>
			<div className="return-top">
				<a href="#">
					<img src="/images/top.png" width="30" height="30" alt="" />
				</a>
			</div>
			<Footer />
		</Fragment>
	);
};

export default DefaultLayout;
